window.app.factory("getAvatarSVG", [
  function() {
    return function getAvatarSVG(text, withBorder = false) {
      text = text.replace(/[[({<"].+[\])}>"]/g, "");
      text = text.replace(/[^A-Za-z ]/g, "");
      const initials = text
        .split(" ")
        .map(s => s[0])
        .join("")
        .substr(0, 3);
      const n = text
        .split("")
        .reduce((a, s, i) => a + (i + 1) * s.charCodeAt(0), 2);

      const colors = "#e00,#5a2,#e82,#a46,#27e,#a72,#371,#558,#dc1".split(",");
      const color = colors[n % colors.length];
      const border = withBorder ? "white" : color;

      const fs = initials.length === 2 ? 48 : 40;
      const y = 43 + fs / 2;

      const svg = `
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1"
        viewBox="0 0 100 100"
        enable-background="new 0 0 100 100"
        xml:space="preserve"
        height="40"
        width="40"
      >
      <circle
        cx="50"
        cy="50"
        r="47"
        fill="${color}"
        stroke="${border}"
        stroke-width="5"
      ></circle>
      <text
        x="50"
        y="${y}"
        fill="white"
        style="font-size:${fs}px;font-family:Arial;sans-serif"
        text-anchor="middle"
      >${initials}</text>
      </svg>`;

      return `data:image/svg+xml;base64,${btoa(svg)}`;
    };
  }
]);



// WEBPACK FOOTER //
// ./src/services/avatarSvg.js